
// Create React App inlines REACT_APP_* into the bundle at build time and picks the
// env file by command: `npm start` reads .env.development, `npm run build` reads
// .env.production. Nothing here is secret - it all ships to the browser - so this is
// per-environment configuration, not a place for credentials.
//
// The fallback is production, matching the value that used to be hardcoded, so a
// build with no env file behaves as it did before rather than failing at runtime.
const config = {
    apiEndpoint: process.env.REACT_APP_API_ENDPOINT || 'https://api.chefsnearby.co.uk',
};

export default config;
